/**
 * Module dependencies.
 */

import { Box } from '@mui/material';
import {
  ContactIcon,
  ContactRow,
  ContactText,
  ContactTitle,
} from './contacts-info.style';

import { FadeInUp } from 'components/atoms/in-view-once/fade-in-up';
import { Fragment, JSX, ReactNode } from 'react';
import { InViewOnce } from 'components/atoms/in-view-once/in-view-once';

/**
 * `Props` type.
 */

type Props = {
  icon: JSX.Element;
  label: string;
  raw?: boolean;
  value: ReactNode;
};

/**
 * Export `ContactInfoField` component.
 */

export function ContactInfoField(props: Props): JSX.Element {
  const { icon, label, raw, value } = props;
  const TextComponent = raw ? Fragment : ContactText;

  return (
    <ContactRow direction={'row'}>
      <InViewOnce AnimationComponent={FadeInUp}>
        <ContactIcon>{icon}</ContactIcon>
      </InViewOnce>

      <Box>
        <InViewOnce AnimationComponent={FadeInUp}>
          <ContactTitle fontWeight={'bold'}>{label}</ContactTitle>
        </InViewOnce>

        <InViewOnce AnimationComponent={FadeInUp}>
          <TextComponent>{value}</TextComponent>
        </InViewOnce>
      </Box>
    </ContactRow>
  );
}
